import { useNotification } from "../../../hooks/useNotification";
import { useVoidPrePaymentsMutation } from "../../../store/apiSlice/invoiceApiSlice";
import { BlurModal } from "../../newLayout/page/components/BlurModal/BlurModal";
import { AddToShipmentCss, DetailsOfOrderCss } from "../../newLayout/page/Allocation/AddToShipment";
import { ModalHeader } from "../../newLayout/page/components/PurchaseOrderDetails/TrackingStatus";
import { Button } from "../../newLayout/page/components/Button/Button";

export {
  canAuthorisePrepayments,
  canMarkPrepaymentsPaid,
  canVoidPrepayments,
} from "./prepaymentStatusHelpers";

/**
 * Confirmation modal to void selected prepayments.
 */
export const VoidPrepaymentsModal = ({
  closeModal,
  prepayments = [],
  onSuccess,
  setSelectedOrder,
}) => {
  const [voidPrePayments, { isLoading }] = useVoidPrePaymentsMutation();
  const notify = useNotification();

  const handleVoid = async event => {
    event.preventDefault();
    const ids = prepayments.map(item => item.id);

    try {
      const response = await voidPrePayments({ ids, prepayments }).unwrap();
      notify({ type: "success", message: response.detail });
      setSelectedOrder?.([]);
      onSuccess?.();
      closeModal();
    } catch (error) {
      const data = error?.data || {};
      const fieldMessage = Array.isArray(data.ids) ? data.ids.join(" ") : data.ids;
      notify({
        type: "error",
        message: data.detail || fieldMessage || "Failed to void prepayment.",
      });
    }
  };

  return (
    <BlurModal>
      <AddToShipmentCss>
        <ModalHeader headerName="Void Prepayment" closeModal={closeModal} />
        <DetailsOfOrderCss>
          <p>
            {prepayments.length === 1
              ? "You're about to void this prepayment. Are you sure?"
              : "You're about to void these prepayments. Are you sure?"}
          </p>
          <ul>
            {prepayments.map(item => (
              <li key={item.id}>{item.name || item.reference}</li>
            ))}
          </ul>
        </DetailsOfOrderCss>

        <Button
          btnName={isLoading ? "Voiding..." : "Void"}
          handler={handleVoid}
          classOfBtn="submitBtn"
        />
      </AddToShipmentCss>
    </BlurModal>
  );
};

